class ImageLoader {
    constructor (images, onDone) {
        this.images = images
        this.loadedImage = 0
        this.promise = new $.Deferred
        this.onDone = onDone;
        this.load()
    }
    load() {
        var previousDefers = []
        for (var i=0; this.images[i]; i++) {
            var image = this.images[i]
            var url = image.url;
            var callback = image.callback
            var currentDefer = $.get({
                url: url,
                success: function(response, b){
                    this.loadedImage++;
                    if (this.images.length === this.loadedImage) {
                        this.promise.resolve()
                    }
                }.bind(this),
            }).done((function(url, loader){
                var thisUrl = url
                return function(response) {
                    if (loader.onDone && typeof(loader.onDone) === 'function') {
                        loader.onDone(loader)
                    }
                }
            }(url, this)))

            if (previousDefers.length === 0) {
                currentDefer.done(callback)
            } else {
                $.when(...previousDefers).done(
                    currentDefer.done(callback)
                );
            }
            previousDefers.push(currentDefer);
        }
    }
}

export default ImageLoader



/** WEBPACK FOOTER **
 ** ./src/intro/image_loader.js
 **/